// VIP (beautiful) numbers + auction admin data layer. Self-contained — does NOT
// touch hot files. Backend `/admin/numbers/*` (migration 194). Fail-soft.
import { api } from '@/lib/api'
import type { FetchParams, FetchResult } from '@/components/DataTable/types'

export interface NumberRow {
  id: number
  display: string
  msisdn: string
  prefix: string
  pattern: string
  price: number
  status: string // available|auction|reserved|sold|blocked
  auction_start_price: number
  auction_current_bid: number
  auction_ends_at: string | null
  bids: number
}

function toResult(rows: NumberRow[], params: FetchParams): FetchResult<NumberRow> {
  const q = params.search.trim().toLowerCase()
  const filtered = q ? rows.filter((r) => `${r.display} ${r.msisdn} ${r.pattern}`.toLowerCase().includes(q)) : rows
  // DataTable pages are 1-indexed (page starts at 1), so shift to a 0-based slice.
  const start = Math.max(0, (params.page - 1) * params.pageSize)
  return { rows: filtered.slice(start, start + params.pageSize), total: filtered.length }
}

export async function fetchNumbers(params: FetchParams): Promise<FetchResult<NumberRow>> {
  try {
    const data = await api.get<{ numbers: NumberRow[] }>('/admin/numbers?limit=200', { signal: params.signal })
    return toResult(data?.numbers ?? [], params)
  } catch {
    return { rows: [], total: 0 }
  }
}

export function createNumber(body: { display: string; pattern: string; price: number }) {
  return api.post<{ id: number }>('/admin/numbers', body)
}
export function updateNumber(id: number, body: { display: string; pattern: string; price: number }) {
  return api.put(`/admin/numbers/${id}`, body)
}
export function setNumberStatus(id: number, status: string) {
  return api.post(`/admin/numbers/${id}/status`, { status })
}
export function sendToAuction(id: number, start_price: number, ends_at: string | null) {
  return api.post(`/admin/numbers/${id}/auction`, { start_price, ends_at: ends_at ?? '' })
}
export function deleteNumber(id: number) {
  return api.del(`/admin/numbers/${id}`)
}
